import { Release } from './enums/releases'
import { Expansions } from './enums/expansions'
import { BeyondLightSeasonHashes, EdgeOfFateSeasonHashes, FinalShapeEpisodeHashes, LightfallSeasonHashes, RenegadesSeasonHashes, ShadowkeepSeasonHashes, WitchQueenSeasonHashes } from './enums/seasons'
import { FinalShapeDungeonHashes, LightfallDungeonHashes, WitchQueenDungeonHashes } from './enums/dungeons'
import { ActivityRecord } from './enums/activities'

export const activities: ActivityRecord = {
  core: [
    {
      name: 'Patrols',
      date: new Date('2017-09-06 09:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `Patrol Missions are in the free roaming world and are always free to play for all players, even if you don't own the expansion related to the destination.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Public Events',
      date: new Date('2017-09-06 09:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `Public Events are in the free roaming world and are always free to play for all players, even if you don't own the expansion related to the destination.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Lost Sectors',
      date: new Date('2017-09-06 09:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `Lost Sectors are in the free roaming world and are always free to play for all players, even if you don't own the expansion related to the destination.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Crucible',
      date: new Date('2017-09-06 09:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `Crucible is the PvP of Destiny 2. It includes multiple game modes, including Competitive with its own scoring system.
      
  Crucible is linked to the title Glorious.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Iron Banner',
      date: new Date('2017-09-06 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `Iron Banner is a periodic event that happens once every four weeks during which no Trials of Osiris can occur.
      
  Iron Banner is linked to the title Iron Lord.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Gambit',
      date: new Date('2018-09-14 17:00:00 UTC'),
      maxPlayers: 4,
      releasedWith: Expansions.Forsaken,
      ownership: [],
      description: `Gambit is free to play for all players.

  A quest within Gambit gives the Malfeasance exotic hand cannon.
      
  Gambit is linked to the title Dredgen.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Trials of Osiris',
      date: new Date('2020-03-13 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: ShadowkeepSeasonHashes.Worthy,
      ownership: [Expansions.Renegades],
      description: `Trials of Osiris requires the Renegades expansion and the completion of the Trials Access quest to play.
      
  Trials of Osiris is linked to the title Flawless.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '',
        '',
        '',
        '',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '',
        '',
        '',
        '',
        '',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '',
        '',
        '',
        '',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
        '(unavailable)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-07 17:00:00 UTC'),
    },
    {
      name: 'New Light Campaign',
      date: new Date('2019-10-01 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Shadowkeep,
      ownership: [],
      description: `The New Light Campaign is available to all players, and is a free-to-play experience that introduces new players to the world of Destiny 2.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Expert Lost Sectors',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `Expert and Master Lost Sectors are in the free roaming world and are always free to play for all players, even if you don't own the expansion related to the destination. They are also on a weekly rotation. They give better rewards when played at higher difficulties, and give exclusive rewards when played solo.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Distortions',
      date: new Date('2026-06-09 09:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
      ownership: [],
      description: `Distortions are in the free roaming world and are always free to play for all players, even if you don't own the expansion related to the destination. They are on a hourly rotation.`,
      isInWorld: true,
      isInPortal: false,
      rotations: [
        '(Dreaming City)',
        '(Throne World)',
        '(Moon)',
        '(Europa)',
        '(Nessus)',
        '(Cosmodrome)',
        '(EDZ)',
      ],
      rotationFrequencyHrs: 1,
      rotationStartDate: new Date('2026-08-07 17:00:00 UTC'),
    },
    {
      name: 'Sparrow Racing League',
      date: new Date('2026-06-09 09:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
      ownership: [],
      description: `Sparrow Racing League is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
  ],
  fireteam: [
    {
      name: 'The Arms Dealer',
      date: new Date('2017-09-06 09:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `The Arms Dealer is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Lake of Shadows',
      date: new Date('2017-09-06 09:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `Lake of Shadows is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Exodus Crash',
      date: new Date('2017-09-06 09:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `Exodus Crash is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Inverted Spire',
      date: new Date('2017-09-06 09:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Destiny2,
      ownership: [],
      description: `The Inverted Spire is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Insight Terminus',
      date: new Date('2018-05-08 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Warmind,
      ownership: [],
      description: `The Insight Terminus is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Warden of Nothing',
      date: new Date('2018-09-14 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Forsaken,
      ownership: [],
      description: `Warden of Nothing is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Corrupted',
      date: new Date('2018-09-14 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Forsaken,
      ownership: [],
      description: `The Corrupted is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Scarlet Keep',
      date: new Date('2019-10-01 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Shadowkeep,
      ownership: [],
      description: `The Scarlet Keep is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Glassway',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `The Glassway is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Disgraced',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `The Disgraced is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Devil\'s Lair',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `The Devil's Lair is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Fallen S.A.B.E.R.',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `Fallen S.A.B.E.R. is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Proving Grounds',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `Proving Grounds is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Warrior',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `The Warrior is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Technocrat',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `The Technocrat is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'The Dark Priestess',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `The Dark Priestess is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Battleground: Behemoth',
      date: new Date('2021-02-09 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: BeyondLightSeasonHashes.Chosen,
      ownership: [],
      description: `Battleground: Behemoth is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Battleground: Foothold',
      date: new Date('2021-02-09 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: BeyondLightSeasonHashes.Chosen,
      ownership: [],
      description: `Battleground: Foothold is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Battleground: Oracle',
      date: new Date('2021-02-09 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: BeyondLightSeasonHashes.Chosen,
      ownership: [],
      description: `Battleground: Oracle is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'The Lightblade',
      date: new Date('2022-02-22 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.TheWitchQueen,
      ownership: [],
      description: `The Lightblade is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Birthplace of the Vile',
      date: new Date('2022-02-22 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.TheWitchQueen,
      ownership: [],
      description: `Birthplace of the Vile is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Expedition',
      date: new Date('2022-08-23 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: WitchQueenSeasonHashes.Plunder,
      ownership: [],
      description: `Expedition is free to play for all players. It is on a daily rotation.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Cosmodrome)',
        '(Europa)',
        '(Nessus)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-07 17:00:00 UTC'),
    },
    {
      name: 'Heist Battleground: Moon',
      date: new Date('2022-12-06 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: WitchQueenSeasonHashes.Seraph,
      ownership: [],
      description: `Heist Battleground: Moon is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Heist Battleground: Mars',
      date: new Date('2022-12-06 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: WitchQueenSeasonHashes.Seraph,
      ownership: [],
      description: `Heist Battleground: Mars is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'HyperNet Current',
      date: new Date('2023-02-28 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Lightfall,
      ownership: [],
      description: `HyperNet Current is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Defiant Battleground: EDZ',
      date: new Date('2023-02-28 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: LightfallSeasonHashes.Defiance,
      ownership: [],
      description: `Defiant Battleground: EDZ is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Savathûn\'s Spire',
      date: new Date('2023-08-22 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: LightfallSeasonHashes.Witch,
      ownership: [],
      description: `Savathûn's Spire is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Liminality',
      date: new Date('2024-06-04 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.FinalShape,
      ownership: [],
      description: `Liminality is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Battleground: Delve',
      date: new Date('2024-07-16 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Echoes,
      ownership: [],
      description: `Battleground: Delve is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Battleground: Conduit',
      date: new Date('2024-07-16 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Echoes,
      ownership: [],
      description: `Battleground: Conduit is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Battleground: Core',
      date: new Date('2024-07-16 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Echoes,
      ownership: [],
      description: `Battleground: Core is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'The Sunless Cell',
      date: new Date('2025-04-01 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Heresy,
      ownership: [],
      description: `The Sunless Cell is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Reclaim',
      date: new Date('2025-10-07 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: EdgeOfFateSeasonHashes.AshAndIron,
      ownership: [],
      description: `Reclaim is free to play for all players. It is on a daily rotation.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Conductor\'s Keep)',
        '(Fallen Bunker)',
        '(Cabal\'s Watch)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-07 17:00:00 UTC'),
    },
  ],
  pinnacle: [
    {
      name: 'The Whisper',
      date: new Date('2018-07-20 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Warmind,
      ownership: [],
      description: `The Whisper exotic mission is free to play for all players. It gives the Whisper of the Worm exotic sniper rifle.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Zero Hour',
      date: new Date('2019-05-08 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Forsaken,
      ownership: [],
      description: `The Zero Hour exotic mission is free to play for all players. It gives the Outbreak Perfected exotic pulse rifle.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Presage',
      date: new Date('2021-02-16 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: BeyondLightSeasonHashes.Chosen,
      ownership: [],
      description: `The Presage exotic mission is free to play for all players. It gives the Dead Man's Tale exotic scout rifle.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Vox Obscura',
      date: new Date('2022-02-22 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: WitchQueenSeasonHashes.Risen,
      ownership: [],
      description: `The Vox Obscura exotic mission is free to play for all players. It gives the Dead Messenger exotic grenade launcher.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Operation: Seraph Shield',
      date: new Date('2022-12-20 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: WitchQueenSeasonHashes.Seraph,
      ownership: [],
      description: `The Operation: Seraph Shield exotic mission is free to play for all players. It gives the Revision Zero exotic pulse rifle.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: '//node.ovrd.AVALON//',
      date: new Date('2023-03-07 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: LightfallSeasonHashes.Defiance,
      ownership: [],
      description: `The //node.ovrd.AVALON// exotic mission is free to play for all players. It gives the Vexcalibur exotic glaive.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'The Coil',
      date: new Date('2023-11-28 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: LightfallSeasonHashes.Wish,
      ownership: [LightfallSeasonHashes.Wish],
      description: `The Coil is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Starcrossed',
      date: new Date('2023-12-19 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: LightfallSeasonHashes.Wish,
      ownership: [],
      description: `The Starcrossed exotic mission is free to play for all players. It gives the Wish-Keeper exotic bow.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Onslaught',
      date: new Date('2024-04-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: LightfallSeasonHashes.IntoTheLight,
      ownership: [],
      description: `Onslaught is free to play for all players. It is on a weekly rotation.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Midtown)',
        '(Widow\'s Court)',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Encore',
      date: new Date('2024-08-27 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Echoes,
      ownership: [],
      description: `The Encore exotic mission is free to play for all players. It gives the Choir of One exotic auto rifle.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Contest of Elders',
      date: new Date('2024-11-19 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Revenant,
      ownership: [],
      description: `Tomb of Elders is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Kell\'s Fall',
      date: new Date('2025-01-07 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Revenant,
      ownership: [],
      description: `The Kell's Fall exotic mission is free to play for all players. It gives the Slayer's Fang exotic shotgun.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Derealize',
      date: new Date('2025-02-11 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Heresy,
      ownership: [],
      description: `The Derealize exotic mission is free to play for all players. It gives the Barrow-Dyad exotic submachine gun.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Heliostat',
      date: new Date('2025-10-07 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: EdgeOfFateSeasonHashes.AshAndIron,
      ownership: [],
      description: `The Heliostat exotic mission is free to play for all players. It gives the Wolfsbane exotic sword.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Oblation: Bloodline',
      date: new Date('2026-06-09 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
      ownership: [],
      description: `The Oblation: Bloodline exotic mission is free to play for all players. It gives the Cull's Shadow exotic fusion rifle.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Oblation: Immolation',
      date: new Date('2026-06-09 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
      ownership: [],
      description: `The Oblation: Immolation exotic mission is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
    {
      name: 'Oblation: Soulfed',
      date: new Date('2026-06-09 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
      ownership: [],
      description: `The Oblation: Soulfed exotic mission is free to play for all players.`,
      isInWorld: true,
      isInPortal: true,
    },
  ],
  arena: [
    {
      name: 'Override',
      date: new Date('2021-05-11 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: BeyondLightSeasonHashes.Splicer,
      ownership: [],
      description: `Override is free to play for all players. It is on a weekly rotation.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Europa)',
        '(Last City)',
        '(Moon)',
        '(Tangle Shore)',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Astral Alignment',
      date: new Date('2021-08-24 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: BeyondLightSeasonHashes.Lost,
      ownership: [],
      description: `Astral Alignment is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Nightmare Containment',
      date: new Date('2022-05-24 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: WitchQueenSeasonHashes.Haunted,
      ownership: [],
      description: `Nightmare Containments are free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'Ketchcrash',
      date: new Date('2022-08-23 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: WitchQueenSeasonHashes.Plunder,
      ownership: [],
      description: `Ketchcrash is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
  ],
  solo: [
    {
      name: 'Skywatch',
      date: new Date('2025-07-15 17:00:00 UTC'),
      maxPlayers: 1,
      releasedWith: EdgeOfFateSeasonHashes.Reclamation,
      ownership: [],
      description: `Skywatch is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Hive)',
        '(Fallen)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Salt Mines',
      date: new Date('2025-07-15 17:00:00 UTC'),
      maxPlayers: 1,
      releasedWith: EdgeOfFateSeasonHashes.Reclamation,
      ownership: [],
      description: `Salt Mines is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Dread)',
        '(Taken)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'The Conflux',
      date: new Date('2025-07-15 17:00:00 UTC'),
      maxPlayers: 1,
      releasedWith: EdgeOfFateSeasonHashes.Reclamation,
      ownership: [],
      description: `The Conflux is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Vex)',
        '(Taken)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Creation (Vex)',
      date: new Date('2025-07-15 17:00:00 UTC'),
      maxPlayers: 1,
      releasedWith: EdgeOfFateSeasonHashes.Reclamation,
      ownership: [],
      description: `Creation is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
    },
    {
      name: 'K1 Logistics',
      date: new Date('2025-07-15 17:00:00 UTC'),
      maxPlayers: 1,
      releasedWith: EdgeOfFateSeasonHashes.Reclamation,
      ownership: [],
      description: `K1 Logistics is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Hive)',
        '(Fallen)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Caldera',
      date: new Date('2025-07-15 17:00:00 UTC'),
      maxPlayers: 1,
      releasedWith: EdgeOfFateSeasonHashes.Reclamation,
      ownership: [],
      description: `Caldera is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Vex)',
        '(Fallen)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Typhon Imperator',
      date: new Date('2025-10-07 17:00:00 UTC'),
      maxPlayers: 1,
      releasedWith: EdgeOfFateSeasonHashes.AshAndIron,
      ownership: [],
      description: `Typhon Imperator is free to play for all players.`,
      isInWorld: false,
      isInPortal: true,
      rotations: [
        '(Cabal)',
        '(Dread)',
      ],
      rotationFrequencyHrs: 24,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
  ],
  raid: [
    {
      name: 'Last Wish',
      date: new Date('2018-09-14 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.Forsaken,
      ownership: [Expansions.Forsaken],
      description: `The Last Wish raid requires the Forsaken pack. It gives the One Thousand Voices exotic fusion rifle.
      
When featured, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final boss will give a key to the final exotic chests, which have a cumulative chance to award the raid's exotic weapon.

Last Wish is linked to the title Rivensbane.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '(featured)',
        '',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Garden of Salvation',
      date: new Date('2019-10-05 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.Shadowkeep,
      ownership: [Expansions.Shadowkeep],
      description: `The Garden of Salvation raid requires the Shadowkeep pack. It gives the Divinity exotic trace rifle.
      
When featured, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear.

Garden of Salvation is linked to the title Enlightened.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '',
        '(featured)',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Deep Stone Crypt',
      date: new Date('2020-11-21 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.BeyondLight,
      ownership: [Expansions.BeyondLight],
      description: `The Deep Stone Crypt raid requires the Beyond Light pack. It gives the Eyes of Tomorrow exotic rocket launcher.
      
When featured, each encounter awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Deep Stone Crypt is linked to the title Descendant.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '',
        '(featured)',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Vault of Glass',
      date: new Date('2021-05-22 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: BeyondLightSeasonHashes.Splicer,
      ownership: [],
      description: `The Vault of Glass raid is free to play for all players. It gives the Vex Mythoclast exotic fusion rifle.
      
When featured or when playing in Master difficulty, each encounter awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Vault of Glass is linked to the title Fatebreaker.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Vow of the Disciple',
      date: new Date('2022-03-05 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.TheWitchQueen,
      ownership: [Expansions.TheWitchQueen],
      description: `The Vow of the Disciple raid requires the Witch Queen expansion. It gives the Collective Obligation exotic pulse rifle.
      
When featured or when playing in Master difficulty, each encounter awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Vow of the Disciple is linked to the title Disciple-Slayer.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'King\'s Fall',
      date: new Date('2022-08-26 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: WitchQueenSeasonHashes.Plunder,
      ownership: [],
      description: `The King's Fall raid is free to play for all players. It gives the Touch of Malice exotic scout rifle.
      
When featured or when playing in Master difficulty, each encounter awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

King's Fall is linked to the title Kingslayer.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Root of Nightmares',
      date: new Date('2023-03-10 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.Lightfall,
      ownership: [Expansions.Lightfall],
      description: `The Root of Nightmares raid requires the Lightfall expansion. It gives the Conditional Finality exotic shotgun.
      
When featured or when playing in Master difficulty, each encounter awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Root of Nightmares is linked to the title Dream Warrior.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Crota\'s End',
      date: new Date('2023-09-01 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: LightfallSeasonHashes.Witch,
      ownership: [],
      description: `The Crota's End raid is free to play for all players. It gives the Necrochasm exotic auto rifle.
      
When featured or when playing in Master difficulty, each encounter awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Crota's End is linked to the title Swordbearer.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Salvation\'s Edge',
      date: new Date('2024-06-07 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.FinalShape,
      ownership: [Expansions.FinalShape],
      description: `The Salvation's Edge raid requires The Final Shape expansion. It gives the Euphony exotic linear fusion rifle.
      
When featured or when playing in Master difficulty, each encounter awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Salvation's Edge is linked to the title Iconoclast.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '(featured)',
        '',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-11 17:00:00 UTC'),
    },
    {
      name: 'Desert Perpetual',
      date: new Date('2025-07-18 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.EdgeOfFate,
      ownership: [Expansions.EdgeOfFate],
      description: `The Desert Perpetual raid requires the Edge of Fate expansion. It gives the Whirling Ovation exotic rocket launcher.

Each encounter awards powerful legendary gear and guarantees Tier 3 gear. Adding Feats increases the Tier of the rewards. Once per week per character, each encounter guarantees at least one Tier 5 item. The final encounter has a cumulative chance to award the raid's exotic weapon.

Desert Perpetual is linked to the title Atemporal.`,
      isInWorld: true,
      isInPortal: true,
      isAlwaysFeatured: true,
    },
    {
      name: 'Desert Perpetual (Epic)',
      date: new Date('2025-09-27 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.EdgeOfFate,
      ownership: [Expansions.EdgeOfFate],
      description: `The Desert Perpetual epic raid requires the Edge of Fate expansion. It gives the Whirling Ovation's catalyst.

Each encounter awards powerful legendary gear and guarantees Tier 3 gear. Adding Feats increases the Tier of the rewards. Once per week per character, each encounter guarantees at least one Tier 5 item. The final encounter has a cumulative chance to award the raid's exotic weapon's catalyst.

Desert Perpetual is linked to the title Atemporal.`,
      isInWorld: true,
      isInPortal: true,
      isAlwaysFeatured: true,
    },
    {
      name: 'Pantheon',
      date: new Date('2026-06-09 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: RenegadesSeasonHashes.MonumentOfTriumph,
      ownership: [],
      description: `Pantheon: Calus Resplendent, Morgeth Surpassing and Insurrection Prime Revolutionary are free to play for all players.
      
Each encounter awards powerful legendary gear and guarantees Tier 3 gear. Adding Feats increases the Tier of the rewards. Once per week per character, each encounter guarantees at least one Tier 5 item. Each encounter has a cumulative chance to give catalysts for legacy exotic raid weapons.

Pantheon is linked to the title Godsbane.`,
      isInWorld: false,
      isInPortal: true,
      isAlwaysFeatured: true,
    },
  ],
  dungeon: [
    {
      name: 'Shattered Throne',
      date: new Date('2018-09-25 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Forsaken,
      ownership: [Expansions.Forsaken],
      description: `The Shattered Throne dungeon requires the Forsaken pack. It gives the Wish-Ender exotic bow.
      
When featured, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '',
        '',
        '(featured)',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Pit of Heresy',
      date: new Date('2019-10-29 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Shadowkeep,
      ownership: [Expansions.Shadowkeep],
      description: `The Pit of Heresy dungeon requires the Shadowkeep pack. It gives the Xenophage exotic machine gun.
      
When featured, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Prophecy',
      date: new Date('2020-06-09 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: ShadowkeepSeasonHashes.Arrivals,
      ownership: [],
      description: `The Prophecy dungeon is free to play for all players.
      
When featured, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Grasp of Avarice',
      date: new Date('2021-12-07 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Anniversary30th,
      ownership: [Expansions.Anniversary30th],
      description: `The Grasp of Avarice dungeon requires the 30th Anniversary pack. It gives the Gjallarhorn exotic rocket launcher.
      
When featured or when playing in Master difficulty, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Duality',
      date: new Date('2022-05-27 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: WitchQueenSeasonHashes.Haunted,
      ownership: [WitchQueenDungeonHashes.Duality],
      description: `The Duality dungeon requires the Witch Queen Dungeon Key. It gives the Heartshadow exotic sword.
      
When featured or when playing in Master difficulty, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Duality is linked to the title Discerptor.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Spire of the Watcher',
      date: new Date('2022-12-09 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: WitchQueenSeasonHashes.Seraph,
      ownership: [WitchQueenDungeonHashes.SpireOfTheWatcher],
      description: `The Spire of the Watcher dungeon requires the Witch Queen Dungeon Key. It gives the Hierarchy of Needs exotic bow.
      
When featured or when playing in Master difficulty, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Spire of the Watcher is linked to the title WANTED.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Ghosts of the Deep',
      date: new Date('2023-05-26 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: LightfallSeasonHashes.Deep,
      ownership: [LightfallDungeonHashes.GhostsOfTheDeep],
      description: `The Ghosts of the Deep dungeon requires the Lightfall Dungeon Key. It gives the Navigator exotic trace rifle.
      
When featured or when playing in Master difficulty, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Ghosts of the Deep is linked to the title Ghoul.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '(featured)',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Warlord\'s Ruin',
      date: new Date('2023-12-01 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: LightfallSeasonHashes.Wish,
      ownership: [LightfallDungeonHashes.WarlordsRuin],
      description: `The Warlord's Ruin dungeon requires the Lightfall Dungeon Key. It gives the Buried Bloodline exotic sidearm.
      
When featured or when playing in Master difficulty, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Warlord's Ruin is linked to the title Wrathbearer.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '(featured)',
        '',
        '',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Vesper\'s Host',
      date: new Date('2024-10-11 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Revenant,
      ownership: [FinalShapeDungeonHashes.VespersHost],
      description: `The Vesper's Host dungeon requires the Final Shape Dungeon Key. It gives the Ice Breaker exotic sniper rifle.
      
When featured or when playing in Master difficulty, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Vesper's Host is linked to the title Unleashed.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '(featured)',
        '',
        '',
        '',
        '',
        '',
        '(featured)',
        '',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Sundered Doctrine',
      date: new Date('2025-02-07 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: FinalShapeEpisodeHashes.Heresy,
      ownership: [FinalShapeDungeonHashes.SunderedDoctrine],
      description: `The Sundered Doctrine dungeon requires the Final Shape Dungeon Key. It gives the Finality's Auger exotic linear fusion rifle.
      
When featured or when playing in Master difficulty, each encounter and challenge completion awards powerful legendary gear and guarantees Tier 5 gear. Otherwise, each encounter and challenge completion awards powerful Tier 3 legendary gear once per character per week. Subsequent completions award at-level Tier 3 gear. The final encounter has a cumulative chance to award the raid's exotic weapon.

Sundered Doctrine is linked to the title Delver.`,
      isInWorld: true,
      isInPortal: true,
      rotations: [
        '',
        '',
        '(featured)',
        '',
        '',
        '',
        '',
        '',
        '(featured)',
        '',
      ],
      rotationFrequencyHrs: 24 * 7,
      rotationStartDate: new Date('2026-08-04 17:00:00 UTC'),
    },
    {
      name: 'Equilibrium',
      date: new Date('2025-12-13 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Renegades,
      ownership: [Expansions.Renegades],
      description: `The Equilibrium dungeon requires the Renegade expansion. It gives the Heirloom exotic combat bow.
      
Each encounter awards powerful legendary gear and guarantees Tier 3 gear. Adding Feats increases the Tier of the rewards. Once per week per character, each encounter guarantees at least one Tier 5 item. The final encounter has a cumulative chance to award the dungeon's exotic weapon.

Equilibrium is linked to the title Praxic.`,
      isInWorld: true,
      isInPortal: true,
      isAlwaysFeatured: true,
    },
  ],
  expansion: [
    {
      name: 'Forsaken Campaign',
      date: new Date('2018-09-14 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Forsaken,
      ownership: [Expansions.Forsaken],
      description: `Forsaken Campaign requires the Forsaken pack, and is on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Blind Well',
      date: new Date('2018-09-14 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Forsaken,
      ownership: [],
      description: `Blind Well activities are free to play for all players.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Ascendant Challenges',
      date: new Date('2018-09-14 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Forsaken,
      ownership: [Expansions.Forsaken],
      description: `Ascendant challenges require the Forsaken pack to access, and are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Shadowkeep Campaign',
      date: new Date('2019-10-01 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Shadowkeep,
      ownership: [],
      description: `Shadowkeep Campaign is free to play for all players. Weekly Shadowkeep Campaign Missions are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Nightmare Hunts',
      date: new Date('2019-10-01 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Shadowkeep,
      ownership: [],
      description: `Nightmare Hunts are free to play for all players, and are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Altar of Sorrow',
      date: new Date('2019-10-01 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Shadowkeep,
      ownership: [],
      description: `Altars of Sorrow are free to play for all players, and its bosses are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Beyond Light Campaign',
      date: new Date('2019-10-01 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [],
      description: `Beyond Light Campaign is free to play for all players.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Empire Hunts',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [Expansions.BeyondLight],
      description: `Empire Hunts require the Beyond Light pack, and are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Exo Challenges',
      date: new Date('2020-11-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.BeyondLight,
      ownership: [Expansions.BeyondLight],
      description: `Exo Challenges require the Beyond Light pack, and are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Dares of Eternity',
      date: new Date('2021-12-07 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.Anniversary30th,
      ownership: [],
      description: `Dares of Eternity are free to play for all players.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Expert Dares of Eternity',
      date: new Date('2021-12-07 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.Anniversary30th,
      ownership: [Expansions.Anniversary30th],
      description: `Expert Dares of Eternity require the 30th Anniversary pack.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'The Witch Queen Campaign',
      date: new Date('2022-02-22 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.TheWitchQueen,
      ownership: [Expansions.TheWitchQueen],
      description: `The Witch Queen Campaign requires the Witch Queen expansion. Weekly The Witch Queen Campaign Missions are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Wellsprings',
      date: new Date('2022-02-22 17:00:00 UTC'),
      maxPlayers: 6,
      releasedWith: Expansions.TheWitchQueen,
      ownership: [Expansions.TheWitchQueen],
      description: `Wellsprings require the Witch Queen expansion, and are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Preservation',
      date: new Date('2022-03-05 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.TheWitchQueen,
      ownership: [Expansions.TheWitchQueen],
      description: `Preservation requires the Witch Queen expansion.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Lightfall Campaign',
      date: new Date('2023-02-28 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Lightfall,
      ownership: [Expansions.Lightfall],
      description: `The Lightfall Campaign Missions requires the Lightfall expansion. Weekly Lightfall Campaign Missions are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Terminal Overloads',
      date: new Date('2023-02-28 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Lightfall,
      ownership: [Expansions.Lightfall],
      description: `Terminal Overloads require the Lightfall expansion to get rewards.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Partitions',
      date: new Date('2023-02-28 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Lightfall,
      ownership: [Expansions.Lightfall],
      description: `Partitions require the Lightfall expansion, and are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'The Final Shape Campaign',
      date: new Date('2024-04-10 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.FinalShape,
      ownership: [Expansions.FinalShape],
      description: `The Final Shape Campaign requires the Final Shape expansion. Weekly Focus Campaign Missions are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Overthrow',
      date: new Date('2024-06-04 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.FinalShape,
      ownership: [Expansions.FinalShape],
      description: `Overthrows require The Final Shape expansion.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Excision',
      date: new Date('2024-06-08 17:00:00 UTC'),
      maxPlayers: 12,
      releasedWith: Expansions.FinalShape,
      ownership: [Expansions.FinalShape],
      description: `Excision requires The Final Shape expansion.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Dual Destiny',
      date: new Date('2024-06-11 17:00:00 UTC'),
      maxPlayers: 2,
      releasedWith: Expansions.FinalShape,
      ownership: [Expansions.FinalShape],
      description: `Dual Destiny requires The Final Shape expansion.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Edge of Fate Campaign',
      date: new Date('2025-07-15 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.EdgeOfFate,
      ownership: [Expansions.EdgeOfFate],
      description: `The Edge of Fate Campaign requires the Edge of Fate expansion. Weekly Edge of Fate Campaign Missions are on a weekly rotation.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'The Sieve',
      date: new Date('2025-07-15 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.EdgeOfFate,
      ownership: [Expansions.EdgeOfFate],
      description: `The Sieve requires the Edge of Fate expansion. It is available during 30 minutes every 104 minutes.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Renegades Campaign',
      date: new Date('2025-12-02 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Renegades,
      ownership: [Expansions.Renegades],
      description: `The Renegades Campaign requires the Renegades expansion.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Faction Job',
      date: new Date('2025-12-02 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Renegades,
      ownership: [Expansions.Renegades],
      description: `Faction Jobs require the Renegades expansion, and are on a daily rotation. They include Bounty Hunt, Sabotage and Smuggle missions on the Lawless Frontier.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Invasion',
      date: new Date('2025-12-02 17:00:00 UTC'),
      maxPlayers: 1,
      releasedWith: Expansions.Renegades,
      ownership: [Expansions.Renegades],
      description: `Invasions require the Renegades expansion.`,
      isInWorld: true,
      isInPortal: false,
    },
    {
      name: 'Fire and Ice',
      date: new Date('2025-12-02 17:00:00 UTC'),
      maxPlayers: 3,
      releasedWith: Expansions.Renegades,
      ownership: [Expansions.Renegades],
      description: `The Fire and Ice exotic mission requires the Renegade expansion. It gives the Praxic Blade exotic sword.`,
      isInWorld: true,
      isInPortal: false,
    },
  ]
}

const releaseDetailArray: Release[] = [
  {
    name: 'Destiny 2',
    id: Expansions.Destiny2,
    date: new Date('2017-09-06 09:00:00 UTC'),
    bought: 'Free to play',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Curse of Osiris',
    id: Expansions.CurseOfOsiris,
    date: new Date('2017-12-05 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Warmind',
    id: Expansions.Warmind,
    date: new Date('2018-05-08 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Forsaken pack',
    id: Expansions.Forsaken,
    date: new Date('2018-09-17 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`The Forsaken pack gives access to:
  - Forsaken exotic weapons and armor
  - The Last Wish raid
  - The Shattered Throne dungeon`,
    longDescription: [
`The pack gives access to everything beyond the Dreaming City destination, including the raid, dungeon and quests.

> **Note**: The Forsaken campaign and the Tangled Shore location have been removed from the game and are no longer available to play. Dreaming City activities are still available. A Timeline activity is available to catch-up on the story. If you own the Forsaken expansion, you automatically own the Forsaken pack.

## Exotic weapons
The Last Wish raid and the Shattered Throne dungeon give the following exotic weapons:`,
[
  2069224589, // One Thousand Voices (raid)
  814876684 // Wish-Ender (dungeon)
],
`If you have never bought the Forsaken expansion, buying the Forsaken Pack for the first time will give you 3 Forsaken Exotic Ciphers. These can be used to instantly unlock any three non-raid Forsaken exotics at the Monument to Lost Light in the Tower:`,
[
  347366834, // Ace of Spades
  1364093401, // The Last Word (S5)
  3588934839, // Le Monarque (S5)
  417164956, // Jötunn (S5)
  3211806999, // Izanagi's Burden (S5)
  3973202132, // Thorn (S6)
  3512014804, // Lumina (S7)
  1201830623, // Truth (S7)
  2816212794 // Bad Juju (S7)
],
`## Titles
Finally, buying the Forsaken pack makes the Cursebreaker and Rivensbane titles available to unlock.`,
    ]
  },
  {
    name: 'Forsaken Annual Pass',
    id: Expansions.AnnualPass,
    date: new Date('2018-12-04 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Shadowkeep pack',
    id: Expansions.Shadowkeep,
    date: new Date('2019-10-01 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`The Shadowkeep pack gives access to:
  - Shadowkeep exotic weapons and armor
  - The Garden of Salvation raid
  - The Pit of Heresy dungeon`,
    longDescription: [
`The pack gives access to everything beyond the Moon destination, including the raid, dungeon and quests.

> **Note**: The Shadowkeep campaign and Nightmare Hunts are now free for all players.

## Campaign rewards
The Shadowkeep campaign gives access to one unique exotic armor piece per class:`,
[
  1537074069, // Phoenix Cradle (Titan)
  2203146422, // Assassin's Cowl (Hunter)
  1996008488 // Stormdancer's Brace (Warlock)
],
`## Exotic weapons
Afterwards, the Pit of Heresy dungeon, the Garden of Salvation raid and an exotic quest give the following exotic weapons:`,
[
  4103414242, // Divinity
  1395261499, // Xenophage
  2232171099 // Deathbringer
],
`## Exotic armor
Additionally, having this pack adds the following exotic armor to the Vex Incursion public event and to Master Rahool Focused Decoding:`,
[
  2326396534, // Severance Enclosure (Titan, S9)
  1190497097, // Citan's Ramparts (Titan, S10)

  1219761634, // The Bombardiers (Hunter, S9)
  2268523867, // Raiju's Harness (Hunter, S10)

  235591051, // Promethium Spur (Warlock, S9)
  2822465023 // Felwinter's Helm (Warlock, S10)
],
`## Titles
Finally, buying the Shadowkeep pack makes the Harbinger and Enlightened titles available to unlock.`,
    ]
  },
  {
    name: 'Season of Undying',
    id: ShadowkeepSeasonHashes.Undying,
    date: new Date('2019-10-01 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of Dawn',
    id: ShadowkeepSeasonHashes.Dawn,
    date: new Date('2019-12-10 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Worthy',
    id: ShadowkeepSeasonHashes.Worthy,
    date: new Date('2020-03-10 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of Arrivals',
    id: ShadowkeepSeasonHashes.Arrivals,
    date: new Date('2020-06-09 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Beyond Light pack',
    id: Expansions.BeyondLight,
    date: new Date('2020-11-10 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`The Beyond Light pack gives access to:
  - Beyond Light exotic weapons and armor
  - The Deep Stone Crypt raid
  - Empire Hunt and Exo Challenge activities`,
    longDescription: [
`The pack gives access to everything beyond the Europa destination, including the raid, quests, Empire Hunts and Exo Challenges.

> **Note**: The Beyond Light campaign and the Stasis subclass are now free for all players. A Timeline activity is also available to catch-up on the story.

## Exotic weapons
Afterwards, the Deep Stone Crypt raid and exotic quests give the following exotic weapons:`,
[
  2399110176, // Eyes of Tomorrow
  1594120904, // No Time to Explain
  370712896, // Salvation's Grip
  3487253372 // The Lament
],
`Empire Hunts activities have a chance to drop the following exotic weapon:`,
[
  2603483885 // Cloudstrike
],
`## Exotic armor
Additionally, having this pack adds the following exotic armor to the Vex Incursion public event and to Master Rahool Focused Decoding:`,
[
  3974038291, // Precious Scars (Titan)
  1467044898, // Icefall Mantle (Titan)
  2321120637, // Cuirass of the Falling Star (Titan, S13)
  1453120846, // The Path of Burning Steps (Titan, S14)
  3267996858, // No Backup Plans (Titan, S15)

  1619425569, // Mask of Bakris (Hunter)
  2415768376, // Athrys's Embrace (Hunter)
  1935198785, // Omnioculus (Hunter, S13)
  1001356380, // Star-Eater Scales (Hunter, S14)
  1702288800, // Radiant Dance Machines (Hunter, S15)

  2316914168, // Dawn Chorus (Warlock)
  2780717641, // Necrotic Grips (Warlock)
  3301944824, // Mantle of Battle Harmony (Warlock, S13)
  3045642045, // Boots of the Assembler (Warlock, S14)
  300502917 // Nothing Manacles (Warlock, S15)
],
`## Titles
Finally, buying the Beyond Light pack makes the Splintered and Descendant titles available to unlock.`,
    ]
  },
  {
    name: 'Season of the Hunt',
    id: BeyondLightSeasonHashes.Hunt,
    date: new Date('2020-11-10 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Chosen',
    id: BeyondLightSeasonHashes.Chosen,
    date: new Date('2021-02-09 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Splicer',
    id: BeyondLightSeasonHashes.Splicer,
    date: new Date('2021-05-11 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Lost',
    id: BeyondLightSeasonHashes.Lost,
    date: new Date('2021-08-24 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: '30th Anniversary pack',
    id: Expansions.Anniversary30th,
    date: new Date('2021-12-07 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`The 30th Anniversary pack gives access to:
  - The Gjallarhorn exotic rocket launcher
  - Dares of Eternity exclusive armor ornaments
  - The Grasp of Avarice dungeon`,
    longDescription: [
`The pack gives access to the Grasp of Avarice dungeon. The dungeon gives the following exotic weapon:`,
[
  1363886209 // Gjallarhorn
],
`## Other rewards
Additionally, the pack gives access to the Expert Dares of Eternity activity, and other cosmetic rewards in Xûr's Treasure Hoard.

## Titles
Finally, buying the 30th Anniversary pack makes the Forerunner title available to unlock`
    ]
  },
  {
    name: 'The Witch Queen',
    id: Expansions.TheWitchQueen,
    date: new Date('2022-02-22 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`The Witch Queen gives access to:
  - The Witch Queen exotic weapons and armor
  - The Witch Queen campaign
  - The Vow of the Disciple raid
  - Wellspring and Preservation activities`,
    longDescription: [
`The expansion gives access to everything beyond the Throne World destination, including the full campaign, raid, quests, Wellspring and Preservation.

> **Note**: The first campaign mission of The Witch Queen is free for all players. A Timeline activity is also available to catch-up on the story.

## Campaign rewards
Finishing the Witch Queen campaign on Expert difficulty instantly grants one of two exotic armor pieces per class:`,
[
  3316517958, // Loreley Splendor Helm (Titan)
  1322544481, // Hoarfrost-Z (Titan)

  1703551922, // Blight Ranger (Hunter)
  2169905051, // Renewal Grasps (Hunter)

  3259193988, // Osmiomancy Gloves (Warlock)
  511888814 // Secant Filaments (Warlock)
],
`## Exotic weapons
Afterwards, the Vow of the Disciple raid, Wellspring activities and exotic quests give the following exotic weapons:`,
[
  3505113722, // Collective Obligation
  46524085, // Osteo Striga
  542203595, // Edge of Concurrence
  2535142413, // Edge of Action
  14194600, // Edge of Intent
  2812324400 // Parasite
],
`## Exotic armor
Additionally, having this expansion adds the following exotic armor to the Vex Incursion public event and to Master Rahool Focused Decoding:`,
[
  3316517958, // Loreley Splendor Helm (Titan)
  1322544481, // Hoarfrost-Z (Titan)
  1443166262, // Second Chance (Titan, S17)
  1703598057, // Point-Contact Cannon Brace (Titan, S18)

  1703551922, // Blight Ranger (Hunter)
  2169905051, // Renewal Grasps (Hunter)
  3453042252, // Caliban's Hand (Hunter, S17)
  461841403, // Gyrfalcon's Hauberk (Hunter, S18)

  3259193988, // Osmiomancy Gloves (Warlock)
  511888814, // Secant Filaments (Warlock)
  1624882687, // Rain of Fire (Warlock, S17)
  1849149215 // Fallen Sunstar (Warlock, S18)
],
`## Titles
Finally, buying The Witch Queen makes the Gumshoe and Disciple-Slayer titles available to unlock.`,
    ]
  },
  {
    name: 'The Witch Queen Dungeon Key',
    id: WitchQueenDungeonHashes.Duality,
    date: new Date('2022-05-27 17:00:00 UTC'),
    bought: 'Costs 2000 Silver',
    active: true,
    hidden: false,
    shortDescription:
`The Witch Queen Dungeon Key gives access to:
  - The Duality dungeon
  - The Spire of the Watcher dungeon`,
    longDescription: [
`The dungeon key gives access to the Duality and Spire of the Watcher dungeons. Those give the following exotic weapons:`,
[
  3664831848, // Heartshadow (S17)
  4174431791 // Hierarchy of Needs (S19)
],
`## Titles
Finally, buying The Witch Queen Dungeon Key makes the Discerptor and WANTED titles available to unlock.`,
    ]
  },
  {
    name: 'The Witch Queen Dungeon Key',
    id: WitchQueenDungeonHashes.SpireOfTheWatcher,
    date: new Date('2022-12-09 17:00:00 UTC'),
    bought: 'Costs 2000 Silver',
    active: false,
    hidden: true,
    shortDescription:
`The Witch Queen Dungeon Key gives access to:
  - The Duality dungeon
  - The Spire of the Watcher dungeon`,
    longDescription: [
`The dungeon key gives access to the Duality and Spire of the Watcher dungeons. Those give the following exotic weapons:`,
[
  3664831848, // Heartshadow (S17)
  4174431791 // Hierarchy of Needs (S19)
],
`## Titles
Finally, buying The Witch Queen Dungeon Key makes the Discerptor and WANTED titles available to unlock.`,
    ]
  },
  {
    name: 'Season of the Risen',
    id: WitchQueenSeasonHashes.Risen,
    date: new Date('2022-02-22 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Haunted',
    id: WitchQueenSeasonHashes.Haunted,
    date: new Date('2022-05-24 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of Plunder',
    id: WitchQueenSeasonHashes.Plunder,
    date: new Date('2022-08-23 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Seraph',
    id: WitchQueenSeasonHashes.Seraph,
    date: new Date('2022-12-06 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Lightfall',
    id: Expansions.Lightfall,
    date: new Date('2023-02-28 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`Lightfall gives access to:
  - Lightfall exotic weapons and armor
  - The Lightfall campaign
  - The Strand subclass
  - The Root of Nightmares raid
  - Terminal Overload and Partition activities`,
    longDescription: [
`The expansion gives access to everything beyond the Neomuna destination, including the full campaign, raid, quests, Terminal Overload rewards and Partitions.

> **Note**: The first campaign mission of Lightfall is free for all players. A Timeline activity is also available to catch-up on the story.

## Campaign rewards
The Lightfall campaign gives access to the Strand subclass and a lot of aspects and fragments.

> ***Warning***: Contrary to most loot, which are unlocks independent of content ownership, switching to a platform where you do not own the Lightfall expansion will prevent equipping and using the Strand subclass. Play on a platform where you own this content to use it.

Finishing the Lightfall campaign on Expert difficulty instantly grants one of two exotic armor pieces per class:`,
[
  3574051505, // Cadmus Ridge Lancecap (Titan)
  3637722482, // Abeyant Leap (Titan)

  192896783, // Cyrtarachne's Facade (Hunter)
  2390471904, // Speedloader Slacks (Hunter)

  3831935023, // Ballidorse Wrathweavers (Warlock)
  2463947681 // Swarmers (Warlock)
],
`## Exotic weapons
Afterwards, the Root of Nightmares raid and exotic quests give the following exotic weapons:`,
[
  3371017761, // Conditional Finality
  3121540812, // Final Warning
  449318888, // Deterministic Chaos
  3118061004 // Winterbite
],
`## Exotic armor
Additionally, having this expansion adds the following exotic armor to the Vex Incursion public event and to Master Rahool Focused Decoding:`,
[
  3574051505, // Cadmus Ridge Lancecap (Titan)
  3637722482, // Abeyant Leap (Titan)
  90009855, // Arbor Warden (Titan, S21)
  2066430310, // Pyrogale Gauntlets (Titan, S22)

  192896783, // Cyrtarachne's Facade (Hunter)
  2390471904, // Speedloader Slacks (Hunter)
  3093309525, // Triton Vice (Hunter, S21)
  3534173884, // Mothkeeper's Wraps (Hunter, S23)

  3831935023, // Ballidorse Wrathweavers (Warlock)
  2463947681, // Swarmers (Warlock)
  2374129871, // Cenotaph Mask (Warlock, S21)
  3234692237 // Briarbinds (Warlock, S22)
],
`## Titles
Finally, buying the Lightfall expansion makes the Virtual Fighter and Dream Warrior titles available to unlock.`,
    ],
    deluxeDescription: 
`The deluxe edition includes:
  - The Lightfall Dungeon key
  - Season of Defiance, Season of the Deep, Season of the Witch, and Season of the Wish`
  },
  {
    name: 'Lightfall Dungeon Key',
    id: LightfallDungeonHashes.GhostsOfTheDeep,
    date: new Date('2023-05-26 17:00:00 UTC'),
    bought: 'Costs 2000 Silver',
    active: true,
    hidden: false,
    shortDescription:
`The Lightfall Dungeon Key gives access to:
  - The Ghosts of The Deep dungeon
  - The Warlord's Ruin dungeon`,
    longDescription: [
`The dungeon key gives access to the Ghosts of The Deep and Warlord's Ruin dungeons. Those give the following exotic weapons:`,
[
  1441805468, // The Navigator (S21)
  3886719505 // Buried Bloodline (S23)
],
`## Titles
Finally, buying The Lightfall Dungeon Key makes the Ghoul and Wrathbearer titles available to unlock.`,
    ]
  },
  {
    name: 'Lightfall Dungeon Key',
    id: LightfallDungeonHashes.WarlordsRuin,
    date: new Date('2023-12-01 17:00:00 UTC'),
    bought: 'Costs 2000 Silver',
    active: false,
    hidden: true,
    shortDescription:
`The Lightfall Dungeon Key gives access to:
  - The Ghosts of The Deep dungeon
  - The Warlord's Ruin dungeon`,
    longDescription: [
`The dungeon key gives access to the Ghosts of The Deep and Warlord's Ruin dungeons. Those give the following exotic weapons:`,
[
  1441805468, // The Navigator (S21)
  3886719505 // Buried Bloodline (S23)
],
`## Titles
Finally, buying The Lightfall Dungeon Key makes the Ghoul and Wrathbearer titles available to unlock.`,
    ]
  },
  {
    name: 'Season of Defiance',
    id: LightfallSeasonHashes.Defiance,
    date: new Date('2023-02-28 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Deep',
    id: LightfallSeasonHashes.Deep,
    date: new Date('2023-05-23 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Witch',
    id: LightfallSeasonHashes.Witch,
    date: new Date('2023-08-22 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Season of the Wish',
    id: LightfallSeasonHashes.Wish,
    date: new Date('2023-11-28 17:00:00 UTC'),
    bought: 'Not purchaseable',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'The Final Shape',
    id: Expansions.FinalShape,
    date: new Date('2024-06-04 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`Final Shape gives access to:
  - Final Shape exotic weapons and armor
  - The Final Shape campaign
  - The full Prismatic subclass
  - The Salvation's Edge raid
  - Overthrow and Excision activities`,
    longDescription: [
`The expansion gives access to everything beyond the Pale Heart destination, including the full campaign, raid, quests and Overthrow, Excision and Dual Destiny activities.

## Campaign rewards
The Final Shape campaign gives access to the full Prismatic subclass and a lot of aspects and fragments.

> **Note**: The first campaign mission of The Final Shape is free for all players. Prismatic is unlocked through the first mission, but additional abilities, aspects and fragments require the full campaign and quests to acquire.

Finishing The Final Shape campaign on Expert difficulty instantly grants one of two exotic armor pieces per class:`,
[
  77153391, // Hazardous Propulsion (Titan)
  3717431477, // Wishful Ignorance (Titan)

  1627691271, // Gifted Conviction (Hunter)
  3001449507, // Balance of Power (Hunter)

  50291571, // Speaker's Sight (Warlock)
  1955548646 // Mataiodoxía (Warlock)
],
`## Exotic weapons and armor
Afterwards, the Salvation's Edge raid and exotic quests give the following exotic weapons and armor:`,
[
  3284383335, // Euphony
  1681583613, // Ergo Sum
  4129629253, // Khvostov 7G-0X
  4207066264, // Microcosm
  2905188646, // Still Hunt
  266021826,  // Stoicism
  2809120022,  // Relativism
  2273643087, // Solipsism
],
`## Exotic armor
Additionally, having this expansion adds the following exotic armor to Master Rahool Focused Decoding:`,
[
  77153391, // Hazardous Propulsion (Titan)
  3717431477, // Wishful Ignorance (Titan)

  1627691271, // Gifted Conviction (Hunter)
  3001449507, // Balance of Power (Hunter)

  50291571, // Speaker's Sight (Warlock)
  1955548646 // Mataiodoxía (Warlock)
],
`## Titles
Finally, buying The Final Shape expansion makes the Transcendent and Iconoclast titles available to unlock.`,
    ],
    deluxeDescription: 
`The deluxe edition includes:
  - The Final Shape Dungeon key
  - Episode: Echoes, Episode: Revenant and Episode: Heresy`
  },
  {
    name: 'The Final Shape Dungeon Key',
    id: FinalShapeDungeonHashes.VespersHost,
    date: new Date('2024-10-11 17:00:00 UTC'),
    bought: 'Costs 2000 Silver',
    active: true,
    hidden: false,
    shortDescription:
`The Final Shape Dungeon Key gives access to:
  - The Vesper's Host dungeon
  - The Sundered Doctrine dungeon`,
    longDescription: [
`The dungeon key gives access to the Vesper's Host and the Sundered Doctrine dungeons. It give the following exotic weapons:`,
[
  1111334348, // Ice Breaker (S25)
  331231237, // Finality's Auger (S26)
],
`## Titles
Finally, buying The Final Shape Dungeon Key makes the Unleashed and Delver titles available to unlock.`,
    ]
  },
  {
    name: 'The Final Shape Dungeon Key',
    id: FinalShapeDungeonHashes.SunderedDoctrine,
    date: new Date('2024-06-04 17:00:00 UTC'),
    bought: 'Costs 2000 Silver',
    active: false,
    hidden: true,
    shortDescription:
``,
    longDescription: []
  },
  {
    name: 'Episode: Echoes',
    id: FinalShapeEpisodeHashes.Echoes,
    date: new Date('2024-06-11 17:00:00 UTC'),
    bought: 'Costs 1500 Silver',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Episode: Revenant',
    id: FinalShapeEpisodeHashes.Revenant,
    date: new Date('2024-10-08 17:00:00 UTC'),
    bought: 'Costs 1500 Silver',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Episode: Heresy',
    id: FinalShapeEpisodeHashes.Heresy,
    date: new Date('2025-02-04 17:00:00 UTC'),
    bought: 'Costs 1500 Silver',
    active: false,
    hidden: false,
    shortDescription: '',
    longDescription: []
  },
  {
    name: 'Edge of Fate',
    id: Expansions.EdgeOfFate,
    date: new Date('2025-07-15 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`Edge of Fate gives access to:
  - Edge of Fate exotic weapons and armor
  - The Edge of Fate campaign
  - The Kepler destination
  - The Desert Perpetual raid
  - The Sieve activity`,
    longDescription: [
`The expansion gives access to everything in the Kepler destination, including the full campaign, raid, quests and the Sieve activity.

## Campaign rewards
> **Note**: The first campaign mission of Edge of Fate is free for all players.

Finishing the Edge of Fate campaign on Legendary difficulty instantly grants one exotic armor pieces per class:`,
[
  2867399974, // Melas Panoplia (Titan)

  2647299044, // Moirai (Hunter)

  894210265, // Eunoia (Warlock)
],
`## Exotic weapons
Afterwards, the Desert Perpetual raid and exotic quests give the following exotic weapons:`,
[
  1202007252, // Whirling Ovation
  648595258, // Graviton Spike
],
`## Exotic armor
Additionally, having this expansion adds the following exotic armor to Master Rahool Focused Decoding:`,
[
  2867399974, // Melas Panoplia (Titan)

  2647299044, // Moirai (Hunter)

  894210265, // Eunoia (Warlock)
],
`## Titles
Finally, buying the Edge of Fate expansion makes the Fated Weapon and Atemporal titles available to unlock.`,
    ],
    deluxeDescription: 
`The deluxe edition includes:
  - The Edge of Fate expansion
  - The Renegades expansion
  - Season: Reclamation and Season: Lawless`
  },
  {
    name: 'Season: Reclamation',
    id: EdgeOfFateSeasonHashes.Reclamation,
    date: new Date('2025-07-15 17:00:01 UTC'),
    bought: 'Costs 1000 Silver',
    active: false,
    hidden: false,
    shortDescription: 
`The rewards pass for Season: Reclamation gives access to:
  - Exclusive cosmetic rewards`,
    longDescription: [
`The pass gives access to exclusive cosmetic rewards.`,
    ]
  },
  {
    name: 'Ash & Iron',
    id: EdgeOfFateSeasonHashes.AshAndIron,
    date: new Date('2025-10-07 17:00:01 UTC'),
    bought: 'Costs 1000 Silver',
    active: false,
    hidden: false,
    shortDescription: 
`The rewards pass for Ash & Iron gives access to:
  - Exclusive cosmetic rewards`,
    longDescription: [
`The pass gives access to exclusive cosmetic rewards.`,
    ]
  },
  {
    name: 'Renegades',
    id: Expansions.Renegades,
    date: new Date('2025-12-02 17:00:00 UTC'),
    bought: 'Costs money',
    active: true,
    hidden: false,
    shortDescription:
`Renegades gives access to:
  - Renegades exotic weapons and armor
  - The Renegades campaign
  - The Lawless Frontier destination
  - The Equilibrium dungeon`,
    longDescription: [
`The expansion gives access to everything in the Lawless Frontier destination, including the full campaign, dungeon and quests.
## Campaign rewards
> **Note**: The first campaign mission of Renegades is free for all players.

Finishing the Renegades campaign on Legendary difficulty instantly grants one exotic armor pieces per class:`,
[
  3357460865, // Praxic Vestment (Titan)
  3538991101, // Fortune's Favor (Hunter)
  1195988317, // Deimosuffusion (Warlock)
],
`## Exotic weapons
During the campaign, the exotic mission Fire And Ice gives the following exotic weapon:`,
[
  3049715579, // Praxic Blade
],
`The expansion gives access to the Equilibrium dungeon. It gives the following exotic weapons:`,
[
  1685137410, // Heirloom (S28)
],
`## Exotic armor
Additionally, having this expansion adds the following exotic armor to Master Rahool Focused Decoding:`,
[
  3357460865, // Praxic Vestment (Titan)
  3538991101, // Fortune's Favor (Hunter)
  1195988317, // Deimosuffusion (Warlock)
],
`## Titles
Finally, buying the Renegades expansion makes the Renegade, Undertaker and Praxic titles available to unlock.`,
    ],
    deluxeDescription: 
`The deluxe edition includes:
  - The Edge of Fate expansion
  - The Renegades expansion
  - Season: Reclamation and Season: Lawless`
  },
  {
    name: 'Season: Lawless',
    id: RenegadesSeasonHashes.Lawless,
    date: new Date('2025-12-02 17:00:01 UTC'),
    bought: 'Costs 1000 Silver',
    active: false,
    hidden: false,
    shortDescription: 
`The rewards pass for Season: Lawless gives access to:
  - Exclusive cosmetic rewards`,
    longDescription: [
`The pass gives access to exclusive cosmetic rewards.`,
    ]
  },
  {
    name: 'Monument of Triumph',
    id: RenegadesSeasonHashes.MonumentOfTriumph,
    date: new Date('2026-06-09 17:00:01 UTC'),
    bought: 'Costs 1000 Silver',
    active: true,
    hidden: false,
    shortDescription: 
`The rewards pass for Monument of Triumph gives access to:
  - Exclusive cosmetic rewards`,
    longDescription: [
`The pass gives access to exclusive cosmetic rewards.`,
    ]
  },
]

export const releaseDetail = new Map(releaseDetailArray.map(obj => [ obj.id, obj ]))
